import { useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCurrentOrganizationId } from 'hooks/use-current-organization-id';

export const useAddOrganizationIdSearchParam = (): void => {
  const organizationId = useCurrentOrganizationId();
  const location = useLocation();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    const currentParams = new URLSearchParams(location.search);
    if (
      !location.pathname.includes('login') &&
      organizationId &&
      currentParams.get('organizationId') !== organizationId
    ) {
      currentParams.set('organizationId', organizationId);
      const newUrl = `${location.pathname}?${currentParams.toString()}${location.hash}`;
      navigate(newUrl, { replace: true });
    }
  }, [location, organizationId, navigate]);
};
